import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Translate from "src/components/Translate";
import useCountDown from "src/functions/useCountdown";
import { sCountdown } from "src/styles/sCountdown.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  targetData: Date;
  isHappening?: (setIsStreamHappening: boolean) => void;
};

const Countdown = ({ targetData, isHappening }: Props) => {
  const [days, hours, minutes, seconds] = useCountDown(targetData);

  isHappening && days + hours + minutes + seconds <= 0 && isHappening(true);

  return (
    <div className={composeClassNames([sCountdown, "countdown"])}>
      <div>
        <div className="number">{days}</div>
        <div className="type">
          <Translate tKey={`Days`} />
        </div>
      </div>
      <span>:</span>
      <div>
        <div className="number">{hours}</div>
        <div className="type">
          <Translate tKey={`Hrs.`} />
        </div>
      </div>
      <span>:</span>
      <div>
        <div className="number">{minutes}</div>
        <div className="type">
          <Translate tKey={`Min.`} />
        </div>
      </div>
      <span>:</span>
      <div>
        <div className="number">{seconds}</div>
        <div className="type">
          <Translate tKey={`Sec.`} />
        </div>
      </div>
    </div>
  );
};

export default Countdown;
